import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal, Button } from '@mui/material';
import FooterDetails from '../../data/FooterDetails.json';
import { assets } from '../../assets/assets';

const QUICK_LINKS = [
  { label: 'Home',            to: '/'               },
  { label: 'Programs',        to: '/programs'       },
  { label: 'ESPRP',           to: '/#esprp'         },
  { label: 'How It Works',    to: '/#how-it-works'  },
  { label: 'Live Projects',   to: '/masterclass'    },
  { label: 'Success Stories', to: '/#success-stories'},
  { label: 'About Us',        to: '/about'          },
  { label: 'Contact Us',      to: '/contact'        },
]

const PROGRAM_LINKS = [
  { label: 'Coding Bootcamp',             to: '/programs' },
  { label: 'Developer Program',           to: '/programs' },
  { label: 'Internship Program',          to: '/programs' },
  { label: 'ESPRP (Employability Skills & Placement Readiness)', to: '/programs' },
]

const RESOURCE_LINKS = [
  { label: 'Blog',              to: '/contact' },
  { label: 'FAQs',              to: '/contact' },
  { label: 'Career Guide',      to: '/contact' },
  { label: 'Privacy Policy',    to: '/contact' },
  { label: 'Terms & Conditions',to: '/contact' },
]

const SOCIALS = [
  { label: 'LinkedIn',  href: 'https://www.linkedin.com/company/upl-snipe/',              icon: <i className="fab fa-linkedin-in"  style={{ color: '#60A5FA', fontSize: 16 }} /> },
  { label: 'Facebook',  href: 'https://www.facebook.com/profile.php?id=100091713887746',  icon: <i className="fab fa-facebook-f"   style={{ color: '#60A5FA', fontSize: 16 }} /> },
  { label: 'Instagram', href: 'https://www.instagram.com/uplsnipe/',                      icon: <i className="fab fa-instagram"    style={{ color: '#60A5FA', fontSize: 16 }} /> },
  { label: 'YouTube',   href: 'https://youtube.com/@uplsnipe',                            icon: <i className="fab fa-youtube"      style={{ color: '#60A5FA', fontSize: 16 }} /> },
]

const Footer = () => {
  const dispatch    = useDispatch();
  const footerData  = FooterDetails.Footerdetails;
  const [modal,      setModal]      = useState({ open: false, data: {} });
  const [deviceFlag, setDeviceFlag] = useState(1);
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const isMobile = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
      navigator.userAgent.toLowerCase()
    );
    setDeviceFlag(isMobile ? 0 : 1);
  }, []);

  const lk = (to, label, extraStyle = {}) => (
    <Link key={to + label} to={to} style={{ fontSize: 13.5, color: '#64748B', textDecoration: 'none', fontWeight: 500, transition: 'color 0.18s', lineHeight: 1, ...extraStyle }}
      onMouseEnter={e => e.currentTarget.style.color = '#93C5FD'}
      onMouseLeave={e => e.currentTarget.style.color = '#64748B'}
      onClick={() => window.scrollTo(0, 0)}
    >
      {label}
    </Link>
  )

  return (
    <>
      <style>{`
        footer.upl-footer,
        div.upl-footer-wrap { background-color: #070F1E !important; }

        @media (max-width: 900px) {
          #footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
        }
        @media (max-width: 540px) {
          #footer-grid { grid-template-columns: 1fr !important; }
          #footer-logo { width: 160px !important; }
        }
      `}</style>

      <div className="upl-footer-wrap" style={{ background: '#070F1E', position: 'relative', zIndex: 1 }}>
        <footer className="upl-footer" style={{ background: '#070F1E', fontFamily: "'Inter','Segoe UI',sans-serif", borderTop: '1px solid rgba(255,255,255,0.06)' }}>

          {/* Top gradient line */}
          <div style={{ height: 3, background: 'linear-gradient(90deg,#0D9488,#0EA5E9,#2563EB)' }} />

          {/* Main columns */}
          <div id="footer-grid" style={{ maxWidth: 1280, margin: '0 auto', padding: '52px 5% 44px', display: 'grid', gridTemplateColumns: '1.8fr 1fr 1.1fr 1fr 1.2fr', gap: 40, alignItems: 'start' }}>

            {/* ── Col 1: Brand ── */}
            <div>
              <img src={assets.logo_img} alt="UPL Snipe" style={{ width: 160, marginBottom: 16, display: 'block', filter: 'brightness(0) invert(1)' }} />
              <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.75, marginBottom: 24, maxWidth: 260 }}>
                UPL SNIPE is committed to empowering learners with industry-relevant skills,
                real-world projects, and career support to achieve their dreams.
              </p>
              {/* Social icons */}
              <div style={{ display: 'flex', gap: 12 }}>
                {SOCIALS.map((s) => (
                  <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                    style={{ width: 36, height: 36, borderRadius: 8, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s, border-color 0.2s', textDecoration: 'none' }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(96,165,250,0.15)'; e.currentTarget.style.borderColor = 'rgba(96,165,250,0.3)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                    title={s.label}
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* ── Col 2: Quick Links ── */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 800, color: '#93C5FD', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Quick Links</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {QUICK_LINKS.map((l) => lk(l.to, l.label))}
              </div>
            </div>

            {/* ── Col 3: Programs ── */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 800, color: '#93C5FD', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Programs</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {PROGRAM_LINKS.map((l) => lk(l.to, l.label))}
              </div>
            </div>

            {/* ── Col 4: Resources ── */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 800, color: '#93C5FD', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Resources</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {RESOURCE_LINKS.map((l) => lk(l.to, l.label))}
                {footerData?.map((d, i) => (
                  <button key={i} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13.5, color: '#64748B', fontWeight: 500, textAlign: 'left', padding: 0, fontFamily: 'inherit', transition: 'color 0.18s' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#93C5FD'}
                    onMouseLeave={e => e.currentTarget.style.color = '#64748B'}
                    onClick={() => setModal({ open: true, data: d })}
                  >
                    {d.name}
                  </button>
                ))}
              </div>
            </div>

            {/* ── Col 5: Colleges / Institutions ── */}
            <div>
              <h4 style={{ fontSize: 12, fontWeight: 800, color: '#93C5FD', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>Colleges / Institutions</h4>
              <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.7, marginBottom: 20 }}>
                We welcome enquiries from colleges to discuss training, assessments and placement readiness programs.
              </p>
              <Link to="/contact" style={{
                display: 'inline-block', padding: '10px 22px',
                background: '#F59E0B', color: '#fff',
                borderRadius: 8, fontSize: 13, fontWeight: 700,
                textDecoration: 'none', transition: 'background 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#D97706'}
              onMouseLeave={e => e.currentTarget.style.background = '#F59E0B'}
              onClick={() => window.scrollTo(0, 0)}
              >
                Send Enquiry
              </Link>
            </div>

          </div>

          {/* Bottom bar */}
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '16px 5%', textAlign: 'center', background: '#040C18' }}>
            <p style={{ fontSize: 12.5, color: '#334155', margin: 0 }}>
              © 2025 UPL SNIPE. All Rights Reserved.
            </p>
          </div>

        </footer>
      </div>

      {/* Scroll to top */}
      {showScroll && (
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ position: 'fixed', bottom: 56, right: 28, zIndex: 9999, width: 48, height: 48, borderRadius: '50%', background: 'linear-gradient(135deg,#0EA5E9,#2563EB)', border: '2px solid rgba(14,165,233,0.3)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 18px rgba(14,165,233,0.35)', transition: 'transform 0.2s ease, box-shadow 0.2s ease' }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(14,165,233,0.5)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 18px rgba(14,165,233,0.35)'; }}
          title="Back to top"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </button>
      )}

      {/* Legal modal */}
      <Modal open={modal.open} onClose={() => setModal({ open: false, data: {} })}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '90%', maxWidth: 600, background: '#0D1F3C', borderRadius: 16, padding: '28px 32px', boxShadow: '0 20px 60px rgba(0,0,0,0.5)', border: '1px solid rgba(14,165,233,0.2)' }}>
          <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <h2 style={{ color: '#F1F5F9', fontWeight: 800, marginBottom: 16 }}>{modal.data.name}</h2>
            <ul style={{ paddingLeft: 20, color: '#94A3B8', lineHeight: 1.8 }}>
              {modal.data.description?.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>
          <Button onClick={() => setModal({ open: false, data: {} })}
            style={{ marginTop: 16, border: '1.5px solid rgba(14,165,233,0.3)', borderRadius: 8, color: '#94A3B8', textTransform: 'none', fontWeight: 600 }}>
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
